import React from "react"
import { all_article_components } from "./all-article-components"

export const getContentComponent = ({ type, react_key, ...rest }) => {
  const Component = all_article_components[type]
  return !!Component ? (
    <Component {...{ key: react_key, in_article: true, ...rest }} />
  ) : null
}
